import React from "react";
import { useState, useEffect, useCallback, useContext } from "react";
import { useSelector, useDispatch } from "react-redux";
import "react-data-table-component-extensions/dist/index.css";
import DataService from ".././../services/tutorial.service";
import { Link, useHistory } from "react-router-dom";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as AiIcons from "react-icons/ai";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-datepicker/dist/react-datepicker.css";
import Navigationtitle from "../include/Navigationtitle";
import { Image, Shimmer } from "react-shimmer";
import LoadingOverlay from "react-loading-overlay-ts";
import { playerlistData, teamlistData, setisfirsttime } from "../../actions/index";
import { encode } from "base-64";
import { auctiondefaultLogo, bgtop1, teamdefaultLogo } from "../../constants/Images";
import { tele } from "../../constants/Images";
import { mask } from "../../constants/Images";
import { plbg } from "../../constants/Images";
import { BASE_PATH } from "../../constants/Global";
// import { Document, Page, View, StyleSheet, useTheme } from '@react-pdf/renderer';

// import { PDFDocument, Page, Text, View, StyleSheet, fonts } from '@react-pdf/renderer';
// import * as fontkit from 'fontkit'; // Import all exports
// import html2pdf from 'html2pdf.js/html2pdf';

import { confirmAlert } from "react-confirm-alert";
import { playerdefaultLogo } from "../../constants/Images";
import { getAge } from "../../Helpers/Helpers";
import NotFound from "../include/NotFound";
import BounceLoader from "react-spinners/ClipLoader";
import jsPDF from 'jspdf';
import { pdfbg } from "../../constants/Images";
import { useRef } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faC, faXmark } from '@fortawesome/free-solid-svg-icons'
import { faFlag } from '@fortawesome/free-solid-svg-icons'
import { faCrown } from '@fortawesome/free-solid-svg-icons'
// import { useHistory } from 'react-router-dom';
import * as XLSX from 'xlsx';
import axios from 'axios';
import html2canvas from 'html2canvas';
import { getDatabase, ref, remove, onValue, set, update } from "firebase/database";
import { FirebaseContext } from '../../FirebaseContext';
import { actlistData } from "../../actions/index";
// import { color } from "html2canvas/dist/types/css/types/color";

function Players(match) {
  const dispatch = useDispatch();
  const [data, setData] = useState([]);
  const [currentauc, setcurrentauc] = useState([]);
  const [pldata, setplData] = useState([]);
  const [dataTeam, setTeamData] = useState([]);
  const [isActive, setActive] = useState(false);
  const [isspnshow, setisspnshow] = useState(false);
  const getpageData = useSelector((state) => state.setplayerlistData);
  const loginuser = useSelector((state) => state.setUserlog);
  const getteampageData = useSelector((state) => state.setteamlistData);
  const getcatpageData = useSelector((state) => state.setcatlistData);

  const aucdatalist = useSelector((state) => state.setactlistData);

  const aid = localStorage.getItem("auction_id");
  const acname = localStorage.getItem("auction_name");
  const [cid, setCid] = useState(loginuser["cid"]);
  const [pdfclk, setpdfclk] = useState(false);
  const [isexcelclk, setisexcelclk] = useState(false);
  const [orderby, setorderby] = useState("");
  const [orderby2, setorderby2] = useState("");
  const [exceltype, setexceltype] = useState("");
  const [colno, setcolno] = useState("");
  const [numofpl, setnumofpl] = useState("");
  const [plcat, setplcat] = useState("");
  const [pdfDataUri, setPdfDataUri] = useState(null);
  const [sts, setsts] = useState("");
  const [catdata, setcatData] = useState("");
  const [filorder, setfilorder] = useState("");
  const [issetdata, setissetdata] = useState(false);
  const [isplnoshow, setisplnoshow] = useState(true);
  const [ismobnoshow, setismobnoshow] = useState(false);
  const [istshirtshow, setistshirtshow] = useState(false);
  const [ispointsshow, setispointsshow] = useState(true);
  const [iscatshow, setiscatshow] = useState(true);
  const [isvalshow, setisvalshow] = useState(true);
  const [isspec1, setisspec1] = useState(true);
  const [isspec2, setisspec2] = useState(true);
  const [isspec3, setisspec3] = useState(true);
  const [imagesLoaded, setImagesLoaded] = useState(false);
  const [baseimage, setbaseimage] = useState("");
  const [renderCount, setRenderCount] = useState(0);
  const [base64Images, setBase64Images] = useState([]);
  const [aucteambase64, setaucteambase64] = useState([]);
  const [aucdata, setaucdata] = useState([]);
  const [auclogo, setauclogo] = useState();
  const [auclogopath, setauclogopath] = useState();
  const [teampath, setteampath] = useState("");
  const [isexcelmore, setisexcelmore] = useState("");
  const [isexcelsp1, setisexcelsp1] = useState(true);
  const [isexcelsp2, setisexcelsp2] = useState(true);
  const [isexcelsp3, setisexcelsp3] = useState(false);
  const [isexceltshirt, setisexceltshirt] = useState(true);
  const [isexceltrouser, setisexceltrouser] = useState(true);
  const [isexcelcat, setisexcelcat] = useState(true);
  const [isexcelplno, setisexcelplno] = useState(true);
  const [isexcelage, setisexcelage] = useState(true);
  const [isexcelmob, setisexcelmob] = useState(true);
  const [isexceldob, setisexceldob] = useState(true);
  const [isexcelpoints, setisexcelpoints] = useState(true);
  const [isexcelteam, setisexcelteam] = useState(true);
  const [isexcelfname, setisexcelfname] = useState(true);
  const [isexceljname, setisexceljname] = useState(true);
  const [isexceljno, setisexceljno] = useState(true);
  const [isexceldetail, setisisexceldetail] = useState(true);
  const [isexcelimage, setisexcelimage] = useState(true);
  const [isexcelbasebid, setisexcelbasebid] = useState(false);
  const [topnum, settopnum] = useState("")
  const [sponsorlogo, setsponsorlogo] = useState("")
  // const [isexcelsp1, setisexcelsp1] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [isexcelmore, setisexcelmore] = useState("");
  // const [excelfields, setexcelfields] = useState({""});

  const updtoken = useSelector((state) => state.updtoken);
  const { upddata } = useContext(FirebaseContext);
  const isfirsttime = useSelector((state) => state.isfirsttime);
  const getaucpageData = useSelector((state) => state.setactlistData);
  const aucmoredetail = useSelector((state) => state.actmoredata);

  // const history = useHistory({ forceRefresh: true });


  const [filter, setFilter] = useState({
    searchText: '',
    selectedStatus: '',
    selectedCategory: '1',
  });
  const imageRefs = useRef([]);
  const aucteamrefs = useRef([]);
  const pldefault = useRef([]);
  // const canvasRefs = useRef([]);

  // const imageRef = useRef(null);
  const pdfContainerRefs = useRef([]);
  // const yourImageRef = useRef(null);
  const history = useHistory();



  const fetchcatData = async () => {
    console.log('cats aa rhi')
    // setActive(true);

    var hdr = {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
        "Authorization": JSON.stringify([{ 'cid': cid, 'token': loginuser["token"] }])
      }
    }

    await DataService.listCategory({ 'aid': aid }, hdr)
      .then(res => {

        let response = res.data;
        console.log(response)
        if (response.success == true) {
          // console.log(responsedata)
          let responsedata = response.data;
          // console.log(" cat list kya h");
          // console.log(responsedata.list.sort((a, b) => a.catord - b.catord));

          setcatData(responsedata.list.sort((a, b) => a.catord - b.catord));
        }
        // setActive(false);

      }).catch(() => {
        console.log('Not valid')
        // setActive(false);
      })
  };
  const fetchaucData = async () => {
    setActive(true);
    // console.log("fetch cid:" + cid);
    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([{ cid: cid, token: loginuser["token"] }]),
      },
    };

    await DataService.listAuction({ myauction: 1 }, hdr)
      .then((res) => {
        let response = res.data;
        console.log(" auc data response")
        console.log(response)

        if (response.success == true) {
          let responsedata = response.data;
          console.log(responsedata)
          setaucdata(responsedata)

          setcurrentauc(responsedata.list.filter((ele) => ele.aid == aid)[0])
          setauclogo(responsedata.list.filter((ele) => ele.aid == aid)[0].logo)
          setauclogopath(responsedata.path)
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        setActive(false);
      });
  };

  const fetchTeamData = async () => {
    console.log('teams aa rhi')
    var hdr = {
      params: {
        frm: 1,
      },
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listTeam({}, hdr)
      .then((res) => {
        let response = res.data;
        console.log(response)
        if (response.success == true) {
          let responsedata = response.data;

          setTeamData(responsedata.list);
          setteampath(responsedata.path);
          dispatch(teamlistData({ responsedata }));
        }
      })
      .catch(() => {
        console.log("Not valid");
      });
  };


  const fetchData = async () => {

    // console.log("aiiiiiid")
    // console.log(aid)
    setActive(true);

    var hdr = {
      headers: {
        "Content-Type": "application/x-www-form-urlencoded", //v
        Authorization: JSON.stringify([
          { cid: cid, aid: aid, token: loginuser["token"] },
        ]),
      },
    };

    await DataService.listPlayer({ self: 1 }, hdr)
      .then((res) => {
        let response = res.data;

        if (response.success == true) {
          let responsedata = response.data;
          console.log(responsedata)
          setData(responsedata);
          setplData(responsedata);
          dispatch(playerlistData({ responsedata }));
        }

        setActive(false);
      })
      .catch(() => {
        console.log("Not valid");
        setActive(false);
      });


  };

  const del = useCallback(
    async (vl, status) => {
      if (status == 1) {
        setActive(true);

        var hdr = {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            Authorization: JSON.stringify([
              { cid: cid, aid: aid, token: loginuser["token"] },
            ]),
          },
        };

        await DataService.deletePlayer({ pid: encode(vl) }, hdr)
          .then((res) => {
            let response = res.data;
            if (response.success == true) {
              const db = getDatabase();
              console.log("vl")
              console.log(vl)
              set(ref(db, 'auction/info/' + aid), { "type": "4", "upd": "3", 'id': vl, "detail": "", "tkn": updtoken });
              toast.success(response.msg, {
                theme: "dark",
                position: "bottom-center",
              });
              const updateitem = data.list.filter((ele, ind) => {
                return ele.pid != vl;
              });
              data.list = updateitem;
              setData(data);
            } else {
              toast.error(response.msg, {
                theme: "colored",
                position: "bottom-center",
              });
            }
            setActive(false);
          })
          .catch(() => {
            console.log("Not valid");
            toast.error("Not valid Server Error", {
              theme: "colored",
              position: "bottom-center",
            });
            setActive(false);
          });
      }
    },
    [data]
  );

  const deldata = (id) => {
    confirmAlert({
      message: "Are you sure delete this record !",
      buttons: [
        {
          label: "Yes",
          onClick: () => del(id, 1),
        },
        {
          label: "No",
          onClick: () => del(id, 0),
        },
      ],
    });
  };

  function gotoimport() {
    history.push(BASE_PATH + 'import-players')
  }
  function pdfdownload() {
    if (data != "") {


      // orderby1-------------------------------------------
      if (orderby == 2) {
        var pdfdata = [...data.list].sort((a, b) =>
          a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1,
        );
      }
      else if (orderby == 1) {
        var pdfdata = data.list
      }
      else if (orderby == 5 || orderby2 == 3) {
        var teamwisefull = []


        dataTeam.forEach((tm) => {
          var teamwise = []
          teamwise = data.list.filter((dt) => dt.tmid == tm.tid)


          if (orderby == 5) {
            if (teamwise.length > 0) {
              console.log("teamwise")
              console.log(teamwise)
              teamwise.sort((a, b) => a.soldseq - b.soldseq)
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele)
            })

          }
          else if (orderby == 7) {
            if (teamwise.length > 0) {

              teamwise.sort((a, b) => b.points - a.points)
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele)
            })

          }
          else if (orderby == 8) {
            if (teamwise.length > 0) {

              teamwise.sort((a, b) =>
                a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1,
              );
            }
            teamwise.forEach((ele) => {
              teamwisefull.push(ele)
            })

          }
          else if (orderby == 6 && catdata !== "") {
            if (teamwise.length > 0) {
              // var catteammain=[]
              console.log("cat team wise")
              console.log(catdata)
              catdata.forEach((ct) => {
                var catteam = []
                teamwise.forEach((tw) => {
                  if (ct.cid == tw.catid) {
                    catteam.push(tw)
                  }
                })
                if (catteam.length > 0) {
                  catteam.forEach((ele) => {
                    teamwisefull.push(ele)
                  })
                }
              })
              teamwise.forEach((tw) => {
                if (tw.catid == "0") {
                  teamwisefull.push(tw)
                }
              })


            }
          }
          else {
            teamwise.forEach((ele) => {
              teamwisefull.push(ele)
            })
          }


        })


        var pdfdata = teamwisefull
      }
      else {
        var pdfdata = data.list
      }
      // orderby2-------------------------------------------
      if (orderby2 == 2 || orderby == 3 || orderby == 4) {
        if (catdata !== "" && catdata !== null) {

          var catwisefull = []

          catdata.forEach((ct) => {
            var catwise = []
            catwise = data.list.filter((dt) => dt.catid == ct.cid)
            if (catwise.length > 0) {
              if (orderby == 2 || orderby == 4) {
                catwise.sort((a, b) =>
                  a.pname.toLowerCase() < b.pname.toLowerCase() ? -1 : 1,
                );
              }
              catwise.forEach((ele) => {
                catwisefull.push(ele)
              })
            }
          })
          var pdfdata = catwisefull
        }


      }
      // else if(orderby2==1 || orderby2==""){
      //   var pdfdata = data.list
      // }
      //
      // column number----------------------------------------------------------
      if (colno == 1) {
        var column = 2;
      }
      else if (colno == 2) {
        var column = 3;
      }
      else {
        var column = 3;
      }
      // perpage--------------------------------------------------
      if (numofpl == "" && colno == 2) {
        var perpage = 27;
      }
      else if (numofpl == "" && colno == 1) {
        var perpage = 14;
      }
      else if (numofpl !== '') {
        var perpage = numofpl;

      }
      else {
        var perpage = 27;

      }


      // status-------------------------------------------------------------------
      if (sts == "" || sts == 1) {
        var pdfdata = pdfdata;
      }
      else {
        if (sts == 2) {
          var pdfdata = pdfdata.filter((pl) => pl.tmid == 0 || pl.tmid == "")
        }
        else if (sts == 3) {
          // console.log("team ke anusaar")
          var pdfdata = pdfdata.filter((pl) => pl.tmid > 0)

        }
      }
      console.log("pdfdata kya h")
      console.log(pdfdata)
      if (pdfdata == [] || pdfdata == null || pdfdata.length == 0) {
        console.log("aat a h")
        alert('No Player Data !!')
        return 0
      }

      const doc = new jsPDF();

      // doc.text('Player List', 15, 10);

      // let yOffset = 20;
      ///-----2/3 column
      ///--first page / Per page record
      //////////////////////////////2X6///////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 12) {
        var perpage = 12;

        var rightbox = 98;
        var bottombox = 40;

        var rectwide = 94;
        var reactheight = 32;

        var imgwidth = 30;
        var imgheight = 30;

        var nameagefont = 12;
        var namex = 33;
        var namey = 5;
        var agex = 53;
        var agey = 11;

        var plnox = 33;
        var plnoy = 11

        var spcffont = 10;
        var spcfx = 33;
        var spcfy = 20;
        var extra = 2;

      }
      ///////////////////////////////////////////2 x 7//////////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 14) {
        var perpage = 14;

        var rightbox = 98;
        var bottombox = 33;

        var rectwide = 94;
        var reactheight = 29;

        var imgwidth = 27;
        var imgheight = 27;

        var nameagefont = 12;
        var namex = 30;
        var namey = 5;
        var agex = 50;
        var agey = 11;

        var plnox = 30;
        var plnoy = 11

        var spcffont = 10;
        var spcfx = 30;
        var spcfy = 20;
        var extra = 2;
      }
      ///////////////////////////////////////////////2 x 8/////////////////////////////////////////////////////////////

      if (column == 2 && perpage == 16) {
        var perpage = 16;

        var rightbox = 98;
        var bottombox = 29;

        var rectwide = 94;
        var reactheight = 26;

        var imgwidth = 24;
        var imgheight = 24;

        var nameagefont = 10;
        var namex = 28;
        var namey = 5;
        var agex = 48;
        var agey = 11;

        var plnox = 28;
        var plnoy = 11

        var spcffont = 9;
        var spcfx = 28;
        var spcfy = 20;

        var extra = 2;
      }
      /////////////////////////////////////// 3 x 8 //////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 24) {
        var perpage = 24;

        var rightbox = 65;
        var bottombox = 29;

        var rectwide = 62;
        var reactheight = 22;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;
        var extra = 6;
      }
      /////////////////////////////////////////////// 3 x 9 ///////////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 27) {
        var perpage = 27;

        var rightbox = 65;
        var bottombox = 26;

        var rectwide = 62;
        var reactheight = 22;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;

        var extra = 6;

      }
      //////////////////////////////////////////// 3 x 10 ///////////////////////////////////////////////////
      if (column == 3 && perpage == 30) {
        var perpage = 30;

        var rightbox = 65;
        var bottombox = 23;

        var rectwide = 62;
        var reactheight = 22;

        var imgwidth = 20;
        var imgheight = 20;

        var nameagefont = 8;
        var namex = 22;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 22;
        var plnoy = 9

        var spcffont = 7;
        var spcfx = 22;
        var spcfy = 16;

        var extra = 6;

      }
      /////////////////////////////////////////////////////////////////////////////////////////////////
      if (column == 3 && perpage == 33) {
        var perpage = 33;

        var rightbox = 65;
        var bottombox = 21;

        var rectwide = 62;
        var reactheight = 20;

        var imgwidth = 18;
        var imgheight = 18;

        var nameagefont = 7;
        var namex = 21;
        var namey = 4;
        var agex = 42;
        var agey = 9;

        var plnox = 21;
        var plnoy = 9

        var spcffont = 6;
        var spcfx = 21;
        var spcfy = 14;
        var extra = 6
      }

      function linechanger(str, count) {
        var plsp = str.split(" ")
        let plsplen = 0;
        let whichsp = 0;
        let firststr = "";
        let secstr = "";
        for (let i = 0; i < plsp.length; i++) {
          plsplen += plsp[i].length;

          if (plsplen > count) {

            break;
          }
          whichsp += 1

        }
        var linearr = []
        for (let y = 0; y < whichsp; y++) {
          if (firststr !== '') {
            firststr += " "
          }
          firststr += plsp[y];
        }
        linearr.push(firststr)

        for (let z = whichsp; z < plsp.length; z++) {
          if (secstr !== '') {
            secstr += " "
          }
          secstr += plsp[z];
        }
        linearr.push(secstr)
        return linearr
      }
      var counter = 0
      var count2 = 0
      var plno = 1
      let x = 10;
      let y = 60;

      doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      // console.log("jjjjjjjjjjjjjjjjjjjjjj")
      // console.log(aucteambase64)
      // doc.setFillColor(255, 255, 255);
      // doc.rect(10, 10, 40, 40,'F');
      // doc.rect(160, 10, 40, 40);

      console.log('aucteambase64[1]')
      // console.log(aucteambase64[0])
      // console.log(aucteambase64[1])
      if (aucteambase64[0]) {

        doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 40, 40);
        if (isspnshow && aucteambase64[1]) {
          doc.addImage(aucteambase64[1], 'JPEG', 160, 10, 40, 40);

        }
        else {

          doc.addImage(aucteambase64[0], 'JPEG', 160, 10, 40, 40);
        }
        // console.log("jjjjjjjjjjjjjjjjjjjjjj2222222222222222")

      }
      else {
        doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 40, 40);
        doc.addImage(auctiondefaultLogo, 'JPEG', 160, 10, 40, 40);

      }
      if (orderby2 == 3) {
        if (aucteambase64[pdfdata[0].tmid]) {

          doc.addImage(aucteambase64[pdfdata[0].tmid], 'JPEG', 10, 10, 40, 40);
        }
      }
      // doc.setDrawColor(72, 104, 153);

      //   doc.rect(9.5, 9.5, 41, 41);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(159.5, 9.5, 41, 41);

      doc.setTextColor(255, 255, 255);
      doc.setFontSize(18);
      if (acname.length < 27) {

        let alen = acname.length * 4
        // doc.setTextColor(196, 147, 14);

        doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
        // doc.setTextColor(255, 255, 255);

      }
      else {
        doc.setFontSize(15);

        var fstr = linechanger(acname, 27)
        let alen1 = fstr[0].length * 3.2

        doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
        if (fstr[1].length <= 25) {
          doc.setFontSize(14);

          let alen2 = fstr[1].length * 2.9

          doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
        } else {
          var fsstr = linechanger(fstr[1], 25);
          doc.setFontSize(14);

          let alen2 = fsstr[0].length * 2.9;
          let alen3 = fsstr[1].length * 2.9;
          doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
          doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);

        }


      }
      doc.setFontSize(10);
      if (orderby2 == 3 || orderby2 == 2) {
        // doc.text('TEAM PLAYER LIST', 88, 45);

      }
      else {
        doc.setTextColor(196, 147, 14);

        doc.text('AUCTION PLAYER LIST', 85, 37);
        doc.setTextColor(255, 255, 255);

      }
      doc.setFontSize(16);



      var dumcatid = pdfdata[0].catid;
      var dumtid = pdfdata[0].tmid;

      pdfdata.forEach((player, index) => {


        if (count2 == 0) {
          if (orderby2 == 2) {

            var catname = catdata.filter((ct) => ct.cid == player.catid)[0].cname
            let clen = catname.length * 2
            doc.text(catname.toUpperCase(), 95 - clen / 2, 35);

          }
          if (orderby2 == 3) {

            var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name;
            let tlen = teamname.length * 2
            doc.text(teamname.toUpperCase(), 95 - tlen / 2, 35);
          }

        }


        if (orderby2 == 2) {
          if (dumcatid !== player.catid) {
            // console.log("cat change ")
            dumcatid = player.catid;
            counter = 0
            // x=10
            count2 = 0

            doc.addPage();

            // if (orderby == 3 || orderby == 4) {

            doc.setFontSize(16);


            var catname = catdata.filter((ct) => ct.cid == player.catid)[0].cname
            // console.log('cathead')
            // console.log(catname)


            // }
            // let x = 10;
            // let y = 60;
            doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            if (aucteambase64[0]) {
              doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 40, 40);
              if (isspnshow && aucteambase64[1]) {
                doc.addImage(aucteambase64[1], 'JPEG', 160, 10, 40, 40);
              }
              else {
                doc.addImage(aucteambase64[0], 'JPEG', 160, 10, 40, 40);
              }
            }
            else {
              doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 40, 40);
              doc.addImage(auctiondefaultLogo, 'JPEG', 160, 10, 40, 40);

            }
            doc.setDrawColor(72, 104, 153);
            doc.rect(9.5, 9.5, 41, 41);

            doc.setDrawColor(72, 104, 153);
            doc.rect(159.5, 9.5, 41, 41);

            doc.setTextColor(255, 255, 255);
            doc.setFontSize(18);

            if (acname.length < 27) {

              let alen = acname.length * 4

              doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
            }
            else {
              doc.setFontSize(15);

              var fstr = linechanger(acname, 27)
              let alen1 = fstr[0].length * 3.2

              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);

                let alen2 = fstr[1].length * 2.9

                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);

                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);

              }



            }
            doc.setFontSize(16);
            if (orderby2 == 3 || orderby2 == 2) {
              // doc.text('TEAM PLAYER LIST', 90, 45);

            } else {

              doc.text('AUCTION PLAYER LIST', 90, 40);
            }
            let clen = catname.length * 2;
            doc.text(catname.toUpperCase(), 95 - clen / 2, 35);
            x = 10;
            y = 60
          }
        }
        if (orderby2 == 3) {
          // console.log("team ki pdfff")

          if (dumtid !== player.tmid) {
            // console.log("team change hui")
            dumtid = player.tmid;
            counter = 0
            count2 = 0

            doc.addPage();
            // if (orderby == 3 || orderby == 4) {

            doc.setFontSize(16);


            var teamname = dataTeam.filter((tm) => tm.tid == player.tmid)[0].name
            // doc.addImage(aucteambase64[player.tmid], 'JPEG', 75, 35, 15, 15);


            doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            if (aucteambase64[0]) {
              if (isspnshow && aucteambase64[1]) {
                doc.addImage(aucteambase64[1], 'JPEG', 160, 10, 40, 40);

              }
              else {

                doc.addImage(aucteambase64[0], 'JPEG', 160, 10, 40, 40);
              }
            }
            else {
              doc.addImage(auctiondefaultLogo, 'JPEG', 160, 10, 40, 40);

            }
            if (aucteambase64[player.tmid]) {
              doc.addImage(aucteambase64[player.tmid], 'JPEG', 10, 10, 40, 40);

            } else {
              doc.addImage(teamdefaultLogo, 'JPEG', 10, 10, 40, 40);

            }
            doc.setDrawColor(72, 104, 153);
            doc.rect(9.5, 9.5, 41, 41);

            doc.setDrawColor(72, 104, 153);
            doc.rect(159.5, 9.5, 41, 41);

            doc.setTextColor(255, 255, 255);
            doc.setFontSize(18);

            if (acname.length < 27) {

              let alen = acname.length * 4

              doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
            }
            else {
              doc.setFontSize(15);

              var fstr = linechanger(acname, 27)
              let alen1 = fstr[0].length * 3.2

              doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
              if (fstr[1].length <= 25) {
                doc.setFontSize(14);

                let alen2 = fstr[1].length * 2.9

                doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
              } else {
                var fsstr = linechanger(fstr[1], 25);
                doc.setFontSize(14);

                let alen2 = fsstr[0].length * 2.9;
                let alen3 = fsstr[1].length * 2.9;
                doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
                doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);

              }
            }
            doc.setFontSize(10);

            // doc.text('TEAM PLAYER LIST', 88, 45);
            doc.setFontSize(16);
            let tlen = teamname.length * 2

            doc.text(teamname, 95 - tlen / 2, 35);
            // doc.addImage(auctiondefaultLogo, 'JPEG', 75, 45, 20, 20);
            x = 10;
            y = 60;
          }
        }
        if (column == 2) {
          if (counter % 2 && counter != 0) {
            x = x + rightbox

          }
          else if (counter != 0) {
            y = y + bottombox
            x = 10;
          }
        }
        else if (column == 3) {
          if (counter % 3 && counter != 0) {
            x = x + rightbox

          }
          else if (counter != 0) {
            y = y + bottombox
            x = 10;
            // console.log("x to 0")
          }
        }



        // doc.setFillColor(255, 255, 255);

        doc.setDrawColor(232, 192, 84);

        doc.rect(x - 1, y - 1, rectwide, reactheight);



        // doc.setFillColor(5, 26, 66);

        // doc.rect(x - 1, y - 1, rectwide, reactheight, 'F');





        var imgindex = pldata.list.findIndex(item => item.pid === player.pid);

        doc.setDrawColor(252, 151, 28);
        doc.setFillColor(252, 151, 28);

        doc.rect(x - .5, y - .5, imgwidth + 1, imgheight + 1, 'F');
        if (base64Images[imgindex]) {
          doc.addImage(base64Images[imgindex], 'PNG', x, y, imgwidth, imgheight);
        }
        else {
          doc.addImage(playerdefaultLogo, 'PNG', x, y, imgwidth, imgheight);
        }

        doc.setFillColor(252, 151, 28);

        doc.rect(x - 2, y - 2, 4.5, 4.5, 'F');



        doc.setFontSize(nameagefont);
        doc.setFont('helvetica', 'bold');
        if (player.pname.length > 20) {
          doc.setFontSize(nameagefont - 1);

          doc.text(player.pname.slice(0, 20).toUpperCase() + '...', x + namex, y + namey - 1);
        }
        else if (player.pname.length > 18) {
          doc.text(player.pname.slice(0, 18).toUpperCase() + '...', x + namex, y + namey - 1);

        }
        else {
          doc.text(player.pname.toUpperCase(), x + namex, y + namey - 1);
        }
        doc.setFontSize(10);


        if (isplnoshow) {
          if (player.pcode.length == 1) {

            doc.text(player.pcode, x - .9, y + 1.3);
          }
          else if (player.pcode.length == 2) {
            doc.setFontSize(8.5);

            doc.text(player.pcode, x - 1.6, y + 1.3);
            doc.setFontSize(10);

          }
          else if (player.pcode.length == 3) {
            doc.setFontSize(7);

            doc.text(player.pcode, x - 1.8, y + 1.3);
            doc.setFontSize(10);

          }

        }



        doc.setFontSize(nameagefont);

        doc.setFont('helvetica', 'normal');
        //Player age
        if (player.age !== "0") {
          doc.setFontSize(6);
          // if (isplnoshow) {
          //   doc.text(`AGE: ${player.age} YR`, x + plnox + 4 + player.pcode.length, y + agey - 2.1);

          // }
          // else {

          doc.text(`AGE: ${player.age} YR`, x + plnox, y + agey - 1.1);
          // }
        }
        if (ismobnoshow && player.mob) {
          doc.setFontSize(6);

          doc.addImage(tele, 'PNG', x + plnox + 20, y + agey - 4.5, 2.5, 2.5);
          doc.text(player.mob, x + plnox + 23, y + agey - 2.1);
        }
        doc.setTextColor(222, 235, 52);
        var ym = 3;
        if (player.age == '0') {

          var ym = 0;
        }

        if ((orderby2 == 3 && isvalshow) && player.points != 0) {
          doc.setFontSize(10);

          doc.setTextColor(222, 235, 52);
          if (currentauc.isdecm == '1') {

            doc.text(parseFloat(player.points).toFixed(2), x + plnox, y + agey + ym - 1);
            var temppx = player.points.length * 1.5

          }
          else {
            doc.text(String(parseInt(player.points)), x + plnox, y + agey + ym - 1);
            var temppx = String(parseInt(player.points)).length * 2


          }
          doc.setFontSize(6);
          doc.text("Points", x + plnox + temppx + 1, y + agey + ym - 1.5);
          doc.setTextColor(255, 255, 255);
          if (colno == 1) {
            ym += 4.5;
          }
          else {
            ym += 3;

          }
        }
        if (player.catid !== "0" && player.catid !== null && iscatshow) {
          doc.setFontSize(6);
          console.log("New player")


          var catname = catdata.filter((ct) => ct.cid == player.catid)[0].cname

          doc.text(catname.toUpperCase(), x + plnox, y + agey + ym - 1);
          // console.log(y + agey + ym - 1)
          ym += 2.2;
        }
        doc.setTextColor(232, 209, 188);

        if (istshirtshow && player.tshirt !== "" && player.tshirt !== null) {
          // console.log(player.pname)
          // console.log(player.name)
          istshirtshow && doc.setFontSize(5);

          doc.text('T-' + player.tshirt, x + plnox, y + agey + ym - 1);
          ym += 2.2;

        }

        doc.setFontSize(5.6);
        if (player.spcf1 && isspec1) {
          if (player.spcf1.length <= 28) {
            doc.text(player.spcf1.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {

            doc.setFontSize(5);

            var fstr = linechanger(player.spcf1, 29)

            doc.text(fstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            doc.text(fstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
          }
          ym += 2.2;
        }

        console.log("spcf2 me aaya")
        if (player.spcf2 && isspec2) {
          if (player.spcf2.length <= 28) {
            doc.text(player.spcf2.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {

            doc.setFontSize(5);

            var fsstr = linechanger(player.spcf2, 29)

            doc.text(fsstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            doc.text(fsstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
          }
          ym += 2.2;

        }
        if (player.spcf3 && isspec3) {
          if (player.spcf3.length <= 28) {
            doc.text(player.spcf3.toUpperCase(), x + spcfx, y + agey + ym - 1);
          } else {

            doc.setFontSize(4.5);

            var fsstr = linechanger(player.spcf3, 29)

            doc.text(fsstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
            ym += 1.5;
            if (fsstr[1].length < 29) {

              doc.text(fsstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);
            } else {
              var fssstr = linechanger(fsstr[1], 29)
              doc.text(fssstr[0].toUpperCase(), x + spcfx, y + agey + ym - 1);
              ym += 1.5;
              doc.text(fssstr[1].toUpperCase(), x + spcfx, y + agey + ym - 1);

            }
          }
          ym += 2.2;

        }

        counter = counter + 1;
        count2 = count2 + 1

        doc.setTextColor(255, 255, 255);

        if (count2 > perpage) {
          if (counter % (perpage + extra) == 0) {
            counter = 0
            doc.addPage();
            doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            x = 10;
            y = 10
          }

        }
        else {
          if (counter % perpage == 0) {

            counter = 0
            doc.addPage();
            doc.addImage(pdfbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
            x = 10;
            y = 10
          }
        }

        plno += 1

      });


      setpdfclk(false)
      if (orderby2 == "" || orderby2 == 1) {

        doc.save(aid + "-" + acname.toUpperCase() + '_PLIST.pdf');
      }
      if (orderby2 == 2) {

        doc.save(aid + "-" + acname.toUpperCase() + '_PLIST_CATEGORY.pdf');
      }
      if (orderby2 == 3) {

        doc.save(aid + "-" + acname.toUpperCase() + '_PLIST_TEAM.pdf');
      }

    }
    else {
      alert("Data is empty !!")
    }

  }
  const firechange = (datasnap) => {
    console.log("firechange")
    console.log(getpageData)

    if (getpageData != 0) {
      let responsedata = {};
      responsedata = {
        responsedata: {
          path: getpageData.responsedata.path,
          aid: aid,
          list: [datasnap.detail, ...getpageData.responsedata.list],
        },
      };
      console.log(responsedata)
      setData(responsedata.responsedata)
      setplData(responsedata.responsedata)

      dispatch(playerlistData(responsedata));



    }
    if (datasnap.type == "3" && datasnap.upd == "2") {
      console.log("firechange edit")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter(
          (ele, ind) => {
            if (ele.pid == datasnap.id) {
              values.age,
                ele.base = datasnap.detail.base,
                ele.catid = datasnap.detail.catid,
                elefname = datasnap.detail.fname,
                ele.icons = datasnap.detail.icons,
                ele.detail = datasnap.detail.detail,
                ele.isnonplay = datasnap.detail.isnonplay,
                ele.isowner = datasnap.detail.isowner,
                ele.jrnm = datasnap.detail.jrnm,
                ele.img = datasnap.detail.img,
                ele.mob = datasnap.detail.mob,
                ele.ownertag = datasnap.detail.ownertag,
                ele.pcode = datasnap.detail.pcode,
                ele.pid = datasnap.detail.pid,
                ele.pname = datasnap.detail.pname,
                ele.spcf1 = datasnap.detail.spcf1,
                ele.spcf2 = datasnap.detail.spcf2,
                ele.spcf3 = datasnap.detail.spcf3,
                ele.trouser = datasnap.detail.trouser,
                ele.tshirt = datasnap.detail.tshirt
            }

            return ele;
          }
        );
        console.log(updateitem)
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        setData(responsedata.responsedXata)
        setplData(responsedata.responsedXata)
        dispatch(playerlistData(responsedata));

      }


    }
    if (datasnap.type == "4" && datasnap.upd == "3") {
      console.log("firechange del")
      if (getpageData != 0) {
        const updateitem = getpageData.responsedata.list.filter((ele, ind) => {
          return ele.pid != datasnap.id;
        });
        let responsedata = {
          responsedata: {
            path: getpageData.responsedata.path,
            aid: aid,
            list: updateitem,
          },
        };
        setData(responsedata.responsedata);
        setplData(responsedata.responsedata);

        dispatch(playerlistData(responsedata));

      }

    }
    if (datasnap.type == "1" && datasnap.upd == "3") {
      if (getaucpageData != 0) {
        const updateitem = getaucpageData.responsedata.list.filter((ele) => ele.aid != datasnap.id)

        let responsedata = {
          responsedata: {
            path: getaucpageData.responsedata.path,
            cid: cid,
            list: updateitem,
          },
        };
        dispatch(actlistData(responsedata));
      }
      history.push(BASE_PATH + 'my-auction')
    }
    if ((datasnap.type == "1" && datasnap.upd == "4") || (datasnap.type == "3" && datasnap.upd == "4")) {
      setData(getpageData.responsedata)
      setplData(getpageData.responsedata)
    }
  }
  useEffect(() => {

    if (aucdata == 0) {
      fetchaucData()

    }
    fetchData();
    if (getpageData == 0) {
      fetchData();
    } else {
      if (getpageData.responsedata.aid == aid) {
        setData(getpageData.responsedata);
      } else {
        let responsedata = getpageData.responsedata;
        responsedata.list = [];
        setData(responsedata);
        fetchData(0);
      }
    }
    if (getteampageData == 0) {
      fetchTeamData();

    }
    if (getcatpageData == 0) {

      fetchcatData();
    }

    setRenderCount((prevCount) => prevCount + 1);
    if (aucmoredetail) {

      if (aucmoredetail.spn?.length > 0) {
        setsponsorlogo(aucmoredetail.spath + aucmoredetail.spn[0].logo + '?c')
      }
    }
  }, []);
  useEffect(() => {
    if (upddata !== null) {
      if (upddata !== isfirsttime) {
        firechange(upddata);
        if (upddata.type == "4") {
          dispatch(setisfirsttime(upddata));
        }
      }
    }
  }, [upddata]);
  const fileToDataUri = (image) => {
    return new Promise((res) => {
      const reader = new FileReader();
      const { type, name, size } = image;
      reader.addEventListener('load', () => {
        res({
          base64: reader.result,
          name: name,
          type,
          size: size,
        })
      });
      reader.readAsDataURL(image);
    })
  }

  const base64 = async () => {



  };


  function getpdf() {
    setpdfclk(true)
    // history.push('/players-pdf')
  }
  function excelclk() {
    setisexcelclk(true)
    // history.push('/players-pdf')
  }

  function exceldownload() {
    if (exceltype == 1 || exceltype == "") {
      var ar3 = []
      var ar4 = []
      // ar4.push(ele.id)
      { isexcelplno && ar4.push("P_no") }
      ar4.push("Name")
      { isexcelmob && ar4.push("Mobile") }
      { isexcelage && ar4.push("Age") }
      { isexceldob && ar4.push("Dob") }
      { isexcelcat && ar4.push("Category") }
      { isexcelsp1 && ar4.push("Specification 1") }
      { isexcelsp2 && ar4.push("Specification 2") }
      { isexcelsp3 && ar4.push("Specification 3") }
      // ar4.push("WK")
      { isexceldetail && ar4.push("Detail") }
      { isexceltshirt && ar4.push("Tshirt") }
      { isexceltrouser && ar4.push("Trouser") }
      { isexceljname && ar4.push("Jersey_name") }
      { isexceljno && ar4.push("Jersey_no") }
      { isexcelbasebid && ar4.push("Base_bid") }
      { isexcelimage && ar4.push("Image") }
      // ar4.push("About")
      ar3.push(ar4)
      // var plcount=0;
      var data2 = data.list.forEach(ele => {
        console.log(ele)
        var ar2 = []
        // ar2.push(ele.id)
        // if(ele.tmid=="0"){
        // plcount+=1

        { isexcelplno && ar2.push(ele.pcode) }
        ar2.push(ele.pname)
        { isexcelmob && ar2.push(ele.mob) }
        { isexcelage && ar2.push((ele.age !== "0" && ele.age !== "") ? ele.age : "-") }
        { isexceldob && ar2.push(ele.dob) }
        if (isexcelcat == true) {
          if (ele.catid !== "0" && ele.catid !== "" && ele.catid !== undefined) {

            catdata.filter((item) => {
              if (item.cid == ele.catid) {
                ar2.push(item.cname)
              }

            })
          }
          else {
            ar2.push('-')
          }
        }

        { isexcelsp1 && ar2.push(ele.spcf1 || "-") }
        { isexcelsp2 && ar2.push(ele.spcf2 || "-") }
        { isexcelsp3 && ar2.push(ele.spcf3 || "-") }
        { isexceldetail && ar2.push(ele.detail || "-") }
        { isexceltshirt && ar2.push(ele.tshirt || "-") }
        { isexceltrouser && ar2.push(ele.trouser || "-") }
        { isexceljname && ar2.push(ele.jrnm || "-") }
        { isexceljno && ar2.push(ele.jrno || "-") }
        { isexcelbasebid && ar2.push(ele.base || "-") }
        { isexcelimage && ar2.push(data.path + ele.img) }
        ar3.push(ar2)
        // }

      });

    }
    else if (exceltype == 2) {
      var ar3 = []
      var ar4 = []
      // ar4.push(ele.id)
      ar4.push("S_no")
      { isexcelplno && ar4.push("P_no") }
      ar4.push("Name")
      { isexcelmob && ar4.push("Mobile") }
      { isexcelage && ar4.push("Age") }
      { isexceldob && ar4.push("Dob") }
      { isexcelcat && ar4.push("Category") }
      { isexcelsp1 && ar4.push("Specification 1") }
      { isexcelsp2 && ar4.push("Specification 2") }
      { isexcelsp3 && ar4.push("Specification 3") }
      // ar4.push("WK")
      { isexceldetail && ar4.push("Detail") }
      { isexceltshirt && ar4.push("Tshirt") }
      { isexceltrouser && ar4.push("Trouser") }
      { isexceljname && ar4.push("Jersey_name") }
      { isexceljno && ar4.push("Jersey_no") }
      { isexcelbasebid && ar4.push("Base_bid") }
      { isexcelimage && ar4.push("Image") }
      ar3.push(ar4)
      var plcount = 0;

      var data2 = data.list.forEach(ele => {
        var ar2 = []
        // ar2.push(ele.id)
        if (ele.tmid == "0") {
          plcount += 1

          ar2.push(plcount)
          { isexcelplno && ar2.push(ele.pcode) }
          ar2.push(ele.pname)
          { isexcelmob && ar2.push(ele.mob) }
          { isexcelage && ar2.push((ele.age !== "0" && ele.age !== "") ? ele.age : "-") }
          { isexceldob && ar2.push(ele.dob || '-') }
          if (isexcelcat == true) {
            if (ele.catid !== "0" && ele.catid !== "" && ele.catid !== undefined) {

              catdata.filter((item) => {
                if (item.cid == ele.catid) {
                  ar2.push(item.cname)
                }

              })
            }
            else {
              ar2.push('-')
            }
          }

          { isexcelsp1 && ar2.push(ele.spcf1 || "-") }
          { isexcelsp2 && ar2.push(ele.spcf2 || "-") }
          { isexcelsp3 && ar2.push(ele.spcf3 || "-") }
          { isexceldetail && ar2.push(ele.detail || "-") }
          { isexceltshirt && ar2.push(ele.tshirt || "-") }
          { isexceltrouser && ar2.push(ele.trouser || "-") }
          { isexceljname && ar2.push(ele.jrnm || "-") }
          { isexceljno && ar2.push(ele.jrno || "-") }
          { isexcelbasebid && ar2.push(ele.base || "-") }
          { isexcelimage && ar2.push(data.path + ele.img) }
          ar3.push(ar2)
        }

      });

    }
    else if (exceltype == 3) {
      fetchTeamData();
      fetchcatData();
      fetchData();
      var ar3 = []
      var ar4 = []
      ar4.push("SNo")
      { isexcelteam && ar4.push("Team") }
      { isexcelplno && ar4.push("P_No") }
      ar4.push("Name")
      { isexcelpoints && ar4.push("Points") }
      { isexcelmob && ar4.push("Mobile") }
      { isexcelage && ar4.push("Age") }
      { isexceldob && ar4.push("Dob") }
      { isexcelcat && ar4.push("Category") }
      { isexcelsp1 && ar4.push("Specification 1") }
      { isexcelsp2 && ar4.push("Specification 2") }
      { isexcelsp3 && ar4.push("Specification 3") }
      { isexcelfname && ar4.push("FName") }
      // ar4.push("Info")
      { isexceldetail && ar4.push("Detail") }
      { isexceltshirt && ar4.push("TShirt") }
      { isexceltrouser && ar4.push("Trouser") }
      { isexceljname && ar4.push("Jersey_Name") }
      { isexceljno && ar4.push("Jersey_No.") }
      { isexcelbasebid && ar4.push("Base_bid") }
      { isexcelimage && ar4.push("Image") }
      ar3.push(ar4)

      dataTeam.forEach((tm) => {
        var teamwise = []
        teamwise = data.list.filter((dt) => dt.tmid == tm.tid)
        var sno = 1;
        teamwise.forEach((ele) => {
          console.log(ele)
          var ar2 = []
          ar2.push(sno)
          { isexcelteam && ar2.push(tm.name) }
          { isexcelplno && ar2.push(ele.pcode) }
          ar2.push(ele.pname)
          { isexcelpoints && ar2.push(ele.points) }
          { isexcelmob && ar2.push(ele.mob || "-") }
          { isexcelage && ar2.push((ele.age !== "0" && ele.age !== "") ? ele.age : "-") }
          { isexceldob && ar2.push(ele.dob) }
          if (isexcelcat == true) {
            if (ele.catid !== "0" && ele.catid !== "" && ele.catid !== undefined) {
              console.log(ele.catid)
              console.log(catdata)
              var catname = catdata.filter((ct) => ct.cid == ele.catid)[0].cname
              ar2.push(catname)
            } else {
              ar2.push("-");
            }
          }

          { isexcelsp1 && ar2.push(ele.spcf1) }
          { isexcelsp2 && ar2.push(ele.spcf2) }
          { isexcelsp3 && ar2.push(ele.spcf3) }
          { isexcelfname && ar2.push(ele.fname || "-") }
          { isexceldetail && ar2.push(ele.detail || "-") }
          { isexceltshirt && ar2.push(ele.tshirt || "-") }
          { isexceltrouser && ar2.push(ele.trouser || "-") }
          { isexceljname && ar2.push(ele.jrnm || "-") }
          { isexceljno && ar2.push(ele.jrno || "-") }
          { isexcelbasebid && ar2.push(ele.base) }

          { isexcelimage && ar2.push(data.path + ele.img) }
          ar3.push(ar2)
          sno += 1;
        })

      });


    }

    const ws = XLSX.utils.aoa_to_sheet(ar3);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Sheet1");
    const excelBlob = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    function s2ab(s) {
      const buf = new ArrayBuffer(s.length);
      const view = new Uint8Array(buf);
      for (let i = 0; i !== s.length; i++) {
        view[i] = s.charCodeAt(i) & 0xFF;
      }
      return buf;
    }
    const blob = new Blob([s2ab(excelBlob)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });


    const url = URL.createObjectURL(blob);

    const a = document.createElement("a");
    a.href = url;
    if (exceltype == 1) {
      a.download = aid + "-" + acname + "_PLIST.xlsx";
    }
    else if (exceltype == 2) {
      a.download = aid + "-" + acname + "_PLIST_UNSOLD.xlsx";
    }
    else if (exceltype == 3) {
      a.download = aid + "-" + acname + "_PLIST_FINAL.xlsx";
    }
    else {
      a.download = aid + "-" + acname + "_PLIST.xlsx";
    }
    a.click();

    URL.revokeObjectURL(url);
  }
  const handleFilterChange = (event) => {
    const { name, value } = event.target;
    setFilter({ ...filter, [name]: value });
  };
  function plfilter() {
    // console.log(filter.selectedStatus)
    if (filter.searchText == "" && filter.selectedStatus == "" && filter.selectedCategory == "1") {
      // console.log("return ja rha")
      return 0

    }
    else {




      const filteredPlayers = getpageData.responsedata.list.filter((player) => {
        const matchesSearchText = (
          isNaN(filter.searchText) && player.pname.toLowerCase().includes(filter.searchText.toLowerCase()) ||
          filter.searchText.length < 7 && player.pcode.toString().includes(filter.searchText) ||
          filter.searchText.length > 7 && player.mob && player.mob.includes(filter.searchText)
        );
        const matchesStatus = (
          (filter.selectedStatus == '5' && player.isskiped == 1) ||
          (filter.selectedStatus == '6' && player.isowner != 0) ||
          (filter.selectedStatus == '4' && player.isfreez == 1) ||
          (filter.selectedStatus == '2' && player.tmid == 0) ||
          (filter.selectedStatus == '3' && player.tmid > 0) ||
          (filter.selectedStatus == "1") ||
          filter.selectedStatus == ""
        );

        const matchesCategory = (filter.selectedCategory !== "1" && player.catid === filter.selectedCategory) || filter.selectedCategory == "1";

        return matchesSearchText && matchesStatus && matchesCategory;
      });
      var responsedata1 = {
        'aid': data.aid,
        'path': data.path,
        'list': filteredPlayers

      }
      setData(responsedata1)
    }
  }

  function setdata() {
    if (issetdata == false) {
      setissetdata(true)

    }
    else {
      setissetdata(false)

    }
  }
  function pdfcls() {
    setpdfclk(false)
  }
  function excelcls() {
    setisexcelclk(false)
  }
  function setorderdata(v) {
    setfilorder(v)
    // console.log(pldata.list)
    if (v == "2") {

      var ordereddata = data.list.sort((a, b) => {

        return a.pname.localeCompare(b.pname, undefined, { sensitivity: 'case' });

      });

    }
    else if (v == "" || v == "1") {
      // console.log("ordereddata")
      // console.log(getpageData.responsedata.list)
      var ordereddata = data.list.sort((a, b) => {
        return a.pcode - b.pcode;
      })

    }

  }
  function onKeyDownHandler(e) {
    if (e.keyCode === 13) {
      plfilter()
    }
  };

  const convertImageToBase64 = (img, index) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;
    ctx.imageSmoothingEnabled = false; // Disable image smoothing

    ctx.drawImage(img, 0, 0, img.width, img.height);

    const base64Data = canvas.toDataURL('image/jpeg', 1);

    if (base64Data) {
      const newarr = base64Images;
      newarr[index] = base64Data
      setBase64Images(newarr);

    }
  };
  const convertaucteamtobase64 = (img, index) => {
    const canvas = document.createElement('canvas');
    const ctx = canvas.getContext('2d');
    canvas.width = img.width;
    canvas.height = img.height;

    ctx.drawImage(img, 0, 0, img.width, img.height);


    const base64Data2 = canvas.toDataURL('image/png');

    if (base64Data2) {

      const newarr2 = aucteambase64;
      newarr2[index] = base64Data2
      console.log(newarr2)
      setaucteambase64(newarr2);

    }

  };
  const handleImageLoad = (index) => {

    return () => {

      convertImageToBase64(imageRefs.current[index], index);


    };
  };
  const handleaucimgload = (index) => {

    return () => {

      convertaucteamtobase64(aucteamrefs.current[index], index);


    };
  };

  const createClippingPath = (width, height, radius) => {
    const path = new Path();
    path.moveTo(radius, 0);
    path.arcTo(width - radius, 0, width, radius, radius);
    path.arcTo(width, height - radius, width - radius, height, radius);
    path.arcTo(radius, height, 0, height - radius, radius);
    path.arcTo(0, radius, radius, 0, radius);
    path.closePath();
    return path;
  };
  const toppdfdownload = () => {
    const doc = new jsPDF();
    doc.addImage(playerdefaultLogo, 'JPEG', 80, 120, 60, 60);

    doc.addImage(bgtop1, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
    if (aucteambase64[0]) {
      doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 40, 40);
      doc.addImage(aucteambase64[0], 'JPEG', 160, 10, 40, 40);
      // console.log("jjjjjjjjjjjjjjjjjjjjjj2222222222222222")

    }
    else {
      doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 40, 40);
      doc.addImage(auctiondefaultLogo, 'JPEG', 160, 10, 40, 40);

    }

    doc.setDrawColor(72, 104, 153);
    doc.rect(9.5, 9.5, 41, 41);

    doc.setDrawColor(72, 104, 153);
    doc.rect(159.5, 9.5, 41, 41);
    doc.setTextColor(255, 255, 255);

    if (acname.length < 27) {

      let alen = acname.length * 4
      // doc.setTextColor(196, 147, 14);

      doc.text(acname.toUpperCase(), 105 - alen / 2, 18);
      // doc.setTextColor(255, 255, 255);

    }
    else {
      doc.setFontSize(15);

      var fstr = linechanger(acname, 27)
      let alen1 = fstr[0].length * 3.2

      doc.text(fstr[0].toUpperCase(), 105 - alen1 / 2, 18);
      if (fstr[1].length <= 25) {
        doc.setFontSize(14);

        let alen2 = fstr[1].length * 2.9

        doc.text(fstr[1].toUpperCase(), 105 - alen2 / 2, 24);
      } else {
        var fsstr = linechanger(fstr[1], 25);
        doc.setFontSize(14);

        let alen2 = fsstr[0].length * 2.9;
        let alen3 = fsstr[1].length * 2.9;
        doc.text(fsstr[0].toUpperCase(), 105 - alen2 / 2, 24);
        doc.text(fsstr[1].toUpperCase(), 105 - alen3 / 2, 30);

      }


    }
    doc.setTextColor(196, 147, 14);
    doc.setFontSize(14);

    doc.text('TOP PLAYERS', 85, 37);
    doc.setTextColor(255, 255, 255);

    // const doc = new jsPDF();

    // const bgData = doc.getImageProperties(pdfbg);
    // const bgWidth = bgData.width;
    // const bgHeight = bgData.height;
    // doc.addImage(pdfbg, 'PNG', 0, 0, bgWidth, bgHeight);

    // // // Load the image
    // const imgData = doc.getImageProperties(playerdefaultLogo);
    // const imgWidth = imgData.width;
    // const imgHeight = imgData.height;
    // const radius = 20;
    // const x = (bgWidth - imgWidth) / 2;
    // const y = (bgHeight - imgHeight) / 2;

    // // Draw the rounded rectangle
    // doc.setDrawColor(0, 0, 0);
    // doc.roundedRect(x, y, imgWidth, imgHeight, radius, true);

    // // Add the image inside the rounded rectangle
    // doc.addImage(playerdefaultLogo, 'PNG', x, y, imgWidth, imgHeight);
    // doc.addImage(playerdefaultLogo, 'PNG', 75, 80, 60, 60);
    doc.save(aid + "-" + acname.toUpperCase() + '_TOP-PLIST.pdf');
    console.log('top pdf');
  }
  // var sizeX=200;
  // var sizeY=220;
  // var ratio=0.5;
  const plwisepdf = () => {
    var doc = new jsPDF({
      orientation: 'portrait',
      unit: 'mm',
      format: [200, 220]
    });
    var soldcount = 0;
    data.list.map((ele, i) => {



      doc.addImage(plbg, 'JPEG', 1, 1, doc.internal.pageSize.width - 2, doc.internal.pageSize.height - 2);
      if (aucteambase64[0]) {
        doc.addImage(aucteambase64[0], 'JPEG', 10, 10, 40, 40);
        doc.addImage(aucteambase64[0], 'JPEG', 150, 10, 40, 40);
        // console.log("jjjjjjjjjjjjjjjjjjjjjj2222222222222222")

      }
      else {
        doc.addImage(auctiondefaultLogo, 'JPEG', 10, 10, 40, 40);
        doc.addImage(auctiondefaultLogo, 'JPEG', 150, 10, 40, 40);

      }
      doc.setFont('helvetica', 'bold');
      doc.setFontSize(18);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(9.5, 9.5, 41, 41);

      // doc.setDrawColor(72, 104, 153);
      // doc.rect(149.5, 9.5, 41, 41);
      doc.setTextColor(255, 255, 255);

      doc.setFillColor(171, 212, 208); // RGB values for blue
      doc.roundedRect(60, 65, 75, 75, 2, 2, 'F'); // 'F' stands for 'fill'
      doc.rect(15, 159, 125, 15, 'F'); // 'F' stands for 'fill'

      doc.setTextColor(31, 29, 122); // Set text color to red
      let plen = ele.pname.length * 4
      doc.text(ele.pname.toUpperCase(), (62.5 - plen / 2) + 15, 169);
      doc.setTextColor(255, 255, 255);

      doc.setFillColor(18, 62, 138); // RGB values for blue
      doc.rect(15, 174, 125, 15, 'F'); // 'F' stands for 'fill'

      doc.rect(140, 149, 43, 43, 'F');
      // doc.roundedRect(140, 149, 43, 43, 5, 5);
      doc.clip();
      if (parseInt(ele.tmid) > 0) {
        if (aucteambase64[ele.tmid]) {

          doc.addImage(aucteambase64[ele.tmid], 'JPEG', 141, 150, 41, 41);
        }
        else {
          doc.addImage(teamdefaultLogo, 'JPEG', 141, 150, 41, 41);
        }
      }
      if (base64Images[i]) {
        doc.addImage(base64Images[i], 'PNG', 61, 66, 73, 73);
      }
      else {
        doc.addImage(playerdefaultLogo, 'PNG', 61, 66, 73, 73);
      }
      // doc.addImage(playerdefaultLogo, 'JPEG', 141, 150, 41, 41);


      doc.setFontSize(14);
      doc.setFont('helvetica', 'normal');

      doc.text('WILL PLAY FOR ', 65, 182);
      doc.setFontSize(18);
      doc.setFont('helvetica', 'bold');


      doc.setFillColor(18, 62, 138); // RGB values for blue
      doc.rect(1, 204, 198, 15, 'F'); // 'F' stands for 'fill'

      doc.setFontSize(18);
      let alen = acname.length * 4
      doc.setFont('helvetica', 'bold');

      doc.text(acname.toUpperCase(), 100 - alen / 2, 213);

      doc.addPage();
      if (ele.tmid > 0) {
        soldcount += 1
      }


    })
    if (soldcount > 0) {

      doc.save(aid + "-" + acname.toUpperCase() + '_TOP-PLIST.pdf');
    }
    else {
      alert("No player sold till now !!")
    }
    console.log('top pdf');
  }

  const generatePDF = () => {
    const element = document.getElementById('content-to-pdf');
    const opt = {
      margin: 0.5,
      filename: 'example.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2 },
      jsPDF: { unit: 'in', format: 'letter', orientation: 'portrait' }
    };

    html2pdf().from(element).set(opt).save();
  };
  return (
    <>
      <LoadingOverlay
        active={isActive}
        spinner={<BounceLoader color={"#337ab7"} />}
      >
        {/* <button onClick={generatePDF}>Generate PDF</button>
            <div id="content-to-pdf">
                <h1>Hello, this is HTML content with an image</h1>
                <img src={aucteambase64[0]} style={{ maxWidth: '100%', height: 'auto' }} alt="Example Image" />
            </div> */}
        {pdfclk &&
          <>
            <div className="pdfdiv"></div>
            <div className="pdfpopup">
              {/* <FontAwesomeIcon className="pdfclose" onClick={pdfcls} icon={faXmark} /> */}
              <div className="pdoptline1">
                <div className="pdopt1">
                  <select class="form-select" value={orderby2} onChange={(e) => { setorderby2(e.target.value) }} aria-label="Default select example">
                    <option selected hidden default disabled value="">Page Record</option>
                    <option value="1">ALL</option>
                    <option value="2">Category wise</option>
                    <option value="3">Team wise</option>
                    <option value="4">Top Players</option>
                    <option value="5">Player wise</option>

                  </select>
                </div>{orderby2 == '4' &&
                  <div className="popt3">
                    <select class="form-select" value={topnum} onChange={(e) => { settopnum(e.target.value) }} aria-label="Default select example">
                      <option selected default hidden disabled value="">TOP ?</option>
                      <option value="1">Top 1</option>
                      <option value="2">Top 2</option>
                      <option value="3">Top 3</option>
                      <option value="4">Top 4</option>
                      <option value="5">Top 5</option>
                      <option value="6">Top 6</option>
                      <option value="7">Top 7</option>
                      <option value="8">Top 8</option>
                      <option value="9">Top 9</option>
                      <option value="10">Top 10</option>
                      <option value="11">Top 11</option>
                    </select>
                  </div>
                }
                {orderby2 !== "4" && <>
                  <div className="pdopt2">

                    <select class="form-select" value={orderby} onChange={(e) => { setorderby(e.target.value) }} aria-label="Default select example">
                      <option selected hidden default disabled value="">Order By</option>
                      {
                        orderby2 == 1 && <>
                          <option value="1">Player Number</option>
                          <option value="2">PLayer Name</option>
                          <option value="3">Category</option>
                          <option value="4">Category-Namewise</option>
                        </>
                      }
                      {
                        orderby2 == 2 && <>
                          <option value="1">Player Number</option>
                          <option value="2">PLayer Name</option>
                        </>
                      }
                      {
                        orderby2 == 3 && <>
                          <option value="5">Sold sequence</option>
                          <option value="6">Category</option>
                          <option value="7">Value</option>
                          <option value="8">PLayer Name</option>
                        </>
                      }

                    </select>
                  </div>
                  <div className="popt3">
                    <select class="form-select" value={colno} onChange={(e) => { setcolno(e.target.value) }} aria-label="Default select example">
                      <option selected default hidden disabled value="">column</option>
                      <option value="1">Two</option>
                      <option value="2">Three</option>
                    </select>
                  </div>
                  <div className="popt4">

                    {
                      colno == 1 &&
                      <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                        <option selected default hidden disabled value="">Perpage Players</option>
                        <option value={12}>First page-12/Rest-14</option>
                        <option value={14}>First page-14/Rest-16</option>
                        <option value={16}>First page-16/Rest-18</option>
                      </select>
                    }
                    {
                      colno == 2 &&
                      <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                        <option selected default hidden disabled value="">Perpage Players</option>
                        <option value={24}>First page-24/Rest-30</option>
                        <option value={27}>First page-27/Rest-33</option>
                        <option value={30}>First page-30/Rest-36</option>
                        <option value={33}>First page-33/Rest-39</option>
                      </select>
                    }
                  </div> </>
                }
              </div>
              {orderby2 != '4' && <>
                <div className="pdoptline2">
                  <div className="pdopt5">
                    <select class="form-select" value={sts} onChange={(e) => { setsts(e.target.value) }} aria-label="Default select example">
                      <option selected hidden default disabled value="">status</option>
                      <option value="1">ALL</option>
                      <option value="2">Available</option>
                      <option value="3">Sold</option>
                    </select>
                  </div>

                  {/* <div> */}
                  <div className="setdataopt">
                    <button className="setdata" onClick={setdata}>Manage more data</button>

                  </div>
                </div>
                <div className="pdoptline2">
                  {issetdata &&
                    <>
                      <div className="showopt">
                        <div className="showoptline">
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setisplnoshow(e.target.checked)} checked={isplnoshow} id="flexCheckDefault1" />
                            <label class="form-check-label checklabel" for="flexCheckDefault1">
                              Show player Number
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setispointsshow(e.target.checked)} checked={ispointsshow} id="flexCheckDefault2" />
                            <label class="form-check-label checklabel" for="flexCheckDefault2">
                              Show points
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setiscatshow(e.target.checked)} checked={iscatshow} id="flexCheckDefault5" />
                            <label class="form-check-label checklabel" for="flexCheckDefault5">
                              Show category
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setisspnshow(e.target.checked)} checked={isspnshow} id="flexCheckDefault56" />
                            <label class="form-check-label checklabel" for="flexCheckDefault6">
                              Show Sponsor
                            </label>
                          </div>
                        </div>
                        <div className="showoptline">
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setismobnoshow(e.target.checked)} checked={ismobnoshow} id="flexCheckDefault3" />
                            <label class="form-check-label checklabel" for="flexCheckDefault3">
                              Show mobile Number
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setistshirtshow(e.target.checked)} checked={istshirtshow} id="flexCheckDefault4" />
                            <label class="form-check-label checklabel" for="flexCheckDefault4">
                              Show Tshirt size
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setisvalshow(e.target.checked)} checked={isvalshow} id="flexCheckDefault10" />
                            <label class="form-check-label checklabel" for="flexCheckDefault10">
                              Show value
                            </label>
                          </div>

                        </div>
                        <div className="showoptline">
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setisspec1(e.target.checked)} checked={isspec1} id="flexCheckDefault7" />
                            <label class="form-check-label checklabel" for="flexCheckDefault7">
                              Show spec_1
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setisspec2(e.target.checked)} checked={isspec2} id="flexCheckDefault8" />
                            <label class="form-check-label checklabel" for="flexCheckDefault8">
                              Show spec_2
                            </label>
                          </div>
                          <div class="form-check">
                            <input class="check1" type="checkbox" onChange={(e) => setisspec3(e.target.checked)} checked={isspec3} id="flexCheckDefault9" />
                            <label class="form-check-label checklabel" for="flexCheckDefault9">
                              Show spec_3
                            </label>
                          </div>

                        </div>
                      </div>

                    </>
                  }
                </div>
              </>
              }
              <button className='btn btn-primary pdclose' onClick={pdfcls} >Close</button>
              <button className='btn btn-primary pddwn' onClick={() => { orderby2 == '4' ? toppdfdownload() : orderby2 == '5' ? plwisepdf() : pdfdownload() }}>Download PDF</button>
            </div>
          </>}
        {isexcelclk &&
          <>
            <div className="pdfdiv"></div>
            <div className="pdfpopup">
              <div className="pdoptline1">
                <div className="pdopt1">
                  <select class="form-select" value={exceltype} onChange={(e) => { setexceltype(e.target.value) }} aria-label="Default select example">
                    <option selected hidden default disabled value="">Excel Type</option>
                    <option value="1">Normal Excel</option>
                    <option value="2">For unsold</option>
                    <option value="3">Final Excel</option>
                    {/* <option value="3">Team wise</option> */}

                  </select>
                </div>

                {/* <div className="popt3">
                  <select class="form-select" value={colno} onChange={(e) => { setcolno(e.target.value) }} aria-label="Default select example">
                    <option selected default hidden disabled value="">column</option>
                    <option value="1">Two</option>
                    <option value="2">Three</option>
                  </select>
                </div>
                <div className="popt4">

                  {
                    colno == 1 &&
                    <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                      <option selected default hidden disabled value="">Perpage Players</option>
                      <option value={12}>First page-12/Rest-14</option>
                      <option value={14}>First page-14/Rest-16</option>
                      <option value={16}>First page-16/Rest-18</option>
                    </select>
                  }
                  {
                    colno == 2 &&
                    <select class="form-select" value={numofpl} onChange={(e) => { setnumofpl(e.target.value) }} aria-label="Default select example">
                      <option selected default hidden disabled value="">Perpage Players</option>
                      <option value={24}>First page-24/Rest-30</option>
                      <option value={27}>First page-27/Rest-33</option>
                      <option value={30}>First page-30/Rest-36</option>
                      <option value={33}>First page-33/Rest-39</option>
                    </select>
                  }
                </div> */}
                <div className="setdataopt">
                  <button className="setdata" onClick={() => setisexcelmore(!isexcelmore)}>Manage more data</button>
                </div>
              </div>
              {isexcelmore &&
                <>
                  <div className="showopt">
                    <div className="showoptline">
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelplno(e.target.checked)} checked={isexcelplno} id="flexCheckDefault1" />
                        <label class="form-check-label checklabel" for="flexCheckDefault1">
                          Show player Number
                        </label>
                      </div>

                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelcat(e.target.checked)} checked={isexcelcat} id="flexCheckDefault5" />
                        <label class="form-check-label checklabel" for="flexCheckDefault5">
                          Show category
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelage(e.target.checked)} checked={isexcelage} id="flexCheckDefault5" />
                        <label class="form-check-label checklabel" for="flexCheckDefault5">
                          Show age
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceldob(e.target.checked)} checked={isexceldob} id="flexCheckDefault5" />
                        <label class="form-check-label checklabel" for="flexCheckDefault5">
                          Show Dob
                        </label>
                      </div>

                      {exceltype == 3 && <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelteam(e.target.checked)} checked={isexcelteam} id="flexCheckDefault2" />
                        <label class="form-check-label checklabel" for="flexCheckDefault2">
                          Show Teams
                        </label>
                      </div>}
                    </div>
                    <div className="showoptline">
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelmob(e.target.checked)} checked={isexcelmob} id="flexCheckDefault3" />
                        <label class="form-check-label checklabel" for="flexCheckDefault3">
                          Show mobile Number
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelfname(e.target.checked)} checked={isexcelfname} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Fname
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisisexceldetail(e.target.checked)} checked={isexceldetail} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Detail
                        </label>
                      </div>
                      {exceltype == 3 && <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelpoints(e.target.checked)} checked={isexcelpoints} id="flexCheckDefault2" />
                        <label class="form-check-label checklabel" for="flexCheckDefault2">
                          Show points
                        </label>
                      </div>}


                      {/* {exceltype==3 && <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisvalshow(e.target.checked)} checked={isvalshow} id="flexCheckDefault10" />
                          <label class="form-check-label checklabel" for="flexCheckDefault10">
                            Show value
                          </label>
                        </div>} */}

                    </div>
                    <div className="showoptline">
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceltshirt(e.target.checked)} checked={isexceltshirt} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Tshirt size
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceltrouser(e.target.checked)} checked={isexceltrouser} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Trouser size
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceljname(e.target.checked)} checked={isexceljname} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Jersey Name
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexceljno(e.target.checked)} checked={isexceljno} id="flexCheckDefault4" />
                        <label class="form-check-label checklabel" for="flexCheckDefault4">
                          Show Jersey Number
                        </label>
                      </div>

                    </div>

                    <div className="showoptline">
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelsp1(e.target.checked)} checked={isexcelsp1} id="flexCheckDefault7" />
                        <label class="form-check-label checklabel" for="flexCheckDefault7">
                          Show spec_1
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelsp2(e.target.checked)} checked={isexcelsp2} id="flexCheckDefault8" />
                        <label class="form-check-label checklabel" for="flexCheckDefault8">
                          Show spec_2
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelsp3(e.target.checked)} checked={isexcelsp3} id="flexCheckDefault9" />
                        <label class="form-check-label checklabel" for="flexCheckDefault9">
                          Show spec_3
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelimage(e.target.checked)} checked={isexcelimage} id="flexCheckDefault9" />
                        <label class="form-check-label checklabel" for="flexCheckDefault9">
                          Show Image Link
                        </label>
                      </div>
                      <div class="form-check">
                        <input class="check1" type="checkbox" onChange={(e) => setisexcelbasebid(e.target.checked)} checked={isexcelbasebid} id="flexCheckDefault9" />
                        <label class="form-check-label checklabel" for="flexCheckDefault9">
                          Show BaseBid
                        </label>
                      </div>

                    </div>
                  </div>
                </>
              }
              {/* <div className="pdoptline2">
                <div className="pdopt5">
                  <select class="form-select" value={sts} onChange={(e) => { setsts(e.target.value) }} aria-label="Default select example">
                    <option selected hidden default disabled value="">status</option>
                    <option value="1">ALL</option>
                    <option value="2">Available</option>
                    <option value="3">Sold</option>
                  </select>
                </div>

                <div className="setdataopt">
                  <button className="setdata" onClick={setdata}>Manage more data</button>

                </div>
              </div>
              <div className="pdoptline2">
                {issetdata &&
                  <>
                    <div className="showopt">
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisplnoshow(e.target.checked)} checked={isplnoshow} id="flexCheckDefault1" />
                          <label class="form-check-label checklabel" for="flexCheckDefault1">
                            Show player Number
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setispointsshow(e.target.checked)} checked={ispointsshow} id="flexCheckDefault2" />
                          <label class="form-check-label checklabel" for="flexCheckDefault2">
                            Show points
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setiscatshow(e.target.checked)} checked={iscatshow} id="flexCheckDefault5" />
                          <label class="form-check-label checklabel" for="flexCheckDefault5">
                            Show category
                          </label>
                        </div>
                      </div>
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setismobnoshow(e.target.checked)} checked={ismobnoshow} id="flexCheckDefault3" />
                          <label class="form-check-label checklabel" for="flexCheckDefault3">
                            Show mobile Number
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setistshirtshow(e.target.checked)} checked={istshirtshow} id="flexCheckDefault4" />
                          <label class="form-check-label checklabel" for="flexCheckDefault4">
                            Show Tshirt size
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisvalshow(e.target.checked)} checked={isvalshow} id="flexCheckDefault10" />
                          <label class="form-check-label checklabel" for="flexCheckDefault10">
                            Show value
                          </label>
                        </div>

                      </div>
                      <div className="showoptline">
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec1(e.target.checked)} checked={isspec1} id="flexCheckDefault7" />
                          <label class="form-check-label checklabel" for="flexCheckDefault7">
                            Show spec_1
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec2(e.target.checked)} checked={isspec2} id="flexCheckDefault8" />
                          <label class="form-check-label checklabel" for="flexCheckDefault8">
                            Show spec_2
                          </label>
                        </div>
                        <div class="form-check">
                          <input class="check1" type="checkbox" onChange={(e) => setisspec3(e.target.checked)} checked={isspec3} id="flexCheckDefault9" />
                          <label class="form-check-label checklabel" for="flexCheckDefault9">
                            Show spec_3
                          </label>
                        </div>

                      </div>
                    </div>
                  </>
                }
              </div> */
              }

              <button className='btn btn-primary pdclose' onClick={excelcls} >Close</button>
              <button className='btn btn-primary pddwn' onClick={exceldownload} >Download Excel</button>
            </div>
          </>}
        <div>
          <Navigationtitle data={match} />
          {pdfDataUri && (
            <iframe
              title="Player Cards PDF"
              src={pdfDataUri}
              width="100%"
              height="500"
              style={{ border: 'none' }}
            />
          )}
          {/* <Document>
            <Page size="A4">
              <View style={styles.imageContainer}>
                <ClipPath id="myClipPath">
                  {createClippingPath(200, 200, radius)}
                </ClipPath>
                <Image style={styles.image} src={auclogopath + auclogo + '?c'} clipPath="url(#myClipPath)" />
              </View>
            </Page>
          </Document> */}
          {/* <button className="btn btn-primary gotoimportbtn " onClick={gotoimport}>Import Players</button> */}
          <button className="btn btn-primary getpdgf " onClick={getpdf}>PDF</button>
          <button className="btn btn-primary getexcel " onClick={excelclk}>Excel</button>
          {/* <button className="btn btn-primary getfinalexcel " onClick={excelclk}>Excel</button> */}
          {/* <Link to={'/players-pdf'}> <button className="btn btn-primary base64 " >base64</button></Link> */}
          {/* <button onClick={() => base64()} className="btn btn-primary base64 " >base64</button> */}
          {/* {console.log("ffffffffffffffffffffffffffffff")}
          {console.log(auclogopath + auclogo)} */}
          <img
            ref={(img) => {
              aucteamrefs.current['0'] = img
              handleaucimgload(0)
            }}
            style={{ display: 'none' }}
            onLoad={handleaucimgload(0)}
            fallback={
              <Shimmer
                width={"100%"}
                height={"auto"}
              />
            }
            src={auclogopath + auclogo + '?c'}
            alt="base img" crossOrigin="Anonymous" />
          <img
            ref={(img) => {
              aucteamrefs.current['1'] = img
              handleaucimgload(1)
            }}
            style={{ display: 'none' }}
            onLoad={handleaucimgload(1)}
            fallback={
              <Shimmer
                width={"100%"}
                height={"auto"}
              />
            }
            src={sponsorlogo}
            alt="base img" crossOrigin="Anonymous" />
          <img
            ref={(img) => {
              pldefault.current['0'] = img
              // handlepldefaultload(0)
            }}
            style={{ display: 'none' }}
            // onLoad={handlepldefaultload(0)}
            fallback={
              <Shimmer
                width={"100%"}
                height={"auto"}
              />
            }
            src={playerdefaultLogo}
            alt="base img" crossOrigin="Anonymous" />

          {dataTeam != "" && dataTeam.map((ele) => {
            // console.log("team se related")
            // console.log(ele)
            return (<img style={{ display: 'none' }} src={teampath + ele.logo + '?c'}
              ref={(img) => { aucteamrefs.current[ele.tid] = img; handleaucimgload(ele.tid) }}
              onLoad={handleaucimgload(ele.tid)}
              alt="base img" crossOrigin="Anonymous" />)
          })}
          <div id="top-categories" className="top-cat-area  bottom-less">

            <div className="container-fluid padding-left-0px">
              <section
                id="advisor"
                className="advisor-area default-padding bottom-less"
              >
                <div className="container-fluid ">




                  {/* <img src="https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg" ref={yourImageRef} alt="" /> */}

                  {/* <img src={base64Images[6]} alt="pl image" /> */}

                  <div className="row">
                    <div className="plheader">
                      <div className="plfilters" onKeyDown={onKeyDownHandler}>
                        <input
                          className="form-control"
                          placeholder="Pl.No / Name / Mob.No"
                          type="text"
                          name="searchText"
                          value={filter.searchText}
                          onChange={handleFilterChange}

                        />
                        <select class="form-select" name="selectedStatus"
                          value={filter.selectedStatus}
                          onChange={handleFilterChange} aria-label="Default select example">
                          <option selected default disabled hidden value="">Status</option>

                          <option value="1">ALL</option>
                          <option value="2">Available</option>
                          <option value="3">Sold</option>
                          <option value="4">Freezed</option>
                          <option value="5">Unold</option>
                          <option value="6">Owners</option>

                        </select>
                        <select class="form-select" name="selectedCategory"
                          value={filter.selectedCategory}
                          onChange={handleFilterChange} aria-label="Default select example">
                          <option selected default value="1">Category(ALL)</option>

                          {catdata !== "" && catdata?.map(
                            (ct) => (
                              <option
                                value={ct.cid}
                                key={ct.cid}
                              >
                                {ct.cname}
                              </option>
                            )
                          )}

                        </select>

                        <button className="btn btn-primary" onClick={() => plfilter()}>Filter</button>
                      </div>
                      <div className="subhead">
                        <select class="form-select" value={filorder} onChange={(e) => { setorderdata(e.target.value) }} aria-label="Default select example">
                          <option selected default disabled hidden value="">Order By</option>

                          <option value="1">Player Number</option>
                          <option value="2">PLayer Name</option>

                        </select>
                      </div>
                    </div>
                    <div className="advisor-items text-center text-light">
                      <h4 className="plcount"> {data?.list?.length} PLAYERS</h4>
                      {data != "" ? (
                        data.list?.map((dt, index) => {
                          // var fgstyle = {
                          //   color: 'none'

                          // }

                          // if (dt.tmid > 0) {

                          //   fgstyle = {
                          //     color: 'red'
                          //   }
                          //   var mytitle = "Sold"
                          // }
                          // else if (dt.isskiped !== "0") {
                          //   fgstyle = {
                          //     color: 'yellow'
                          //   }
                          // }
                          // else if (dt.isnonplay !== "0") {
                          //   fgstyle = {
                          //     color: 'blue'
                          //   }
                          //   var mytitle = "Non Playing"
                          // }
                          var pcolor = 'jj'
                          if (dt.isskiped !== "0" || dt.tmid > 0 || dt.isnonplay !== "0") {
                            var pcolor = 'plred';
                          }
                          else if (dt.isskiped == 1) {
                            // var pcolor = "plfreeze";
                          }
                          if (dt.isfreez == 1) {
                            var pcolor = "plred plfreeze";
                          }



                          return (
                            <div className="col-md-4 col-sm-6 col-xs-6 single-item padding-10">
                              <div style={{ overflow: 'visible' }} className="advisor-item">
                                <div style={{ overflow: 'visible' }} className="info-box plbox">
                                  {/* {
                                    (dt.isskiped !== "0" || dt.tmid > 0 || dt.isnonplay !== "0") &&
                                    <FontAwesomeIcon className="fgicon" title={mytitle} style={fgstyle} icon={faFlag} />

                                  } */}


                                  <div className="row mar-right-0">

                                    <div className="col-md-4 col-sm-6   padding-r-0 ">
                                      <div className="plimgh">
                                        <div className="plnumber">{dt.pcode}</div>
                                       
                                        {/* <canvas
                                          ref={(ref) => {
                                            if (ref) {
                                              const canvas = ref;
                                              const ctx = canvas.getContext('2d');
                                              const img = new Image();
                                              img.src = 'https://mscspa.s3.amazonaws.com/playersphoto/230510124585589.jpg'; 
                                              img.onload = () => ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
                                              canvasRefs.current.push(canvas);
                                            }
                                          }}
                                          width={100}
                                          height={100}
                                          style={{ display: 'flex' }}
                                        /> */}
                                        <img

                                          ref={(img) => {

                                            imageRefs.current[index] = img
                                            handleImageLoad(index)
                                          }}
                                          onLoad={handleImageLoad(index)}
                                          fallback={
                                            <Shimmer
                                              width={"100%"}
                                              height={"auto"}
                                            />
                                          }
                                          src={
                                            (dt.img == null || dt.img == "")
                                              ? playerdefaultLogo
                                              : data.path + dt.img + '?c'
                                          }
                                          crossOrigin="Anonymous"
                                        />
                                        {parseInt(dt.tmid) > 0 && <div className="soldptsbox">{parseInt(dt.points).toFixed(currentauc.isdecm)}</div>}
                                        {/* {console.log(data.path + dt.img)} */}
                                      </div>

                                      <div className="card-icon player-edit pleditbtns">
                                        <Link
                                          className="edit-icon"
                                          to={
                                            "/edit-auction-player/" +
                                            encode(dt.pid)
                                          }
                                        >
                                          <AiIcons.AiFillEdit></AiIcons.AiFillEdit>
                                        </Link>

                                        <Link
                                          className="delete-icon"
                                          to={"#"}
                                          onClick={() => deldata(dt.pid)}
                                        >
                                          <AiIcons.AiFillDelete></AiIcons.AiFillDelete>
                                        </Link>
                                      </div>
                                    </div>

                                    <div className="col-sm-6 width-full padding-l-0">
                                      <div className={`info-title player-info p-name ${pcolor}`}>
                                        {dt.pname}
                                        {dt.isowner>0 &&
                                         <FontAwesomeIcon icon={faCrown} className="f-crown-icon" />
                                        }
                                      </div>

                                      <div className="info-title player-info">
                                        <div className="row plin">
                                          {/* <div className="col-md-6 col-xs-12 plcode">

                                            {" "}
                                            P.NO.{" "}
                                            {" "}
                                            :<b className="player-info-b">{dt.pcode} </b>
                                          </div> */}

                                          {(dt.age !== "0" && dt.age !== "") && <div className="col-md-6 col-xs-12 ">
                                            Age{" "}
                                            : <b className="player-info-b">{dt.age
                                              //getAge(dt.dob)
                                            }</b>
                                          </div>}
                                        </div>

                                        <div className="row spcs">
                                          <div className="info-title player-info col-md-12 ">
                                            {dt.spcf1}
                                          </div>

                                          <div className="info-title player-info col-md-12">
                                            {dt.spcf2}
                                          </div>
                                          {(parseInt(dt.tmid) > 0 && dataTeam != "") &&
                                            <div className="info-title player-info col-md-12 ">

                                              <span className="fz-1"> Sold to</span><span className="soldteam">   {dataTeam && dataTeam.filter((ele) => ele.tid == dt.tmid)[0].name}</span>
                                            </div>
                                          }
                                        </div>
                                      </div>
                                    </div>
                                    {/* <div className={badg}>Sold</div> */}
                                    {/* {
                                      dt.isfreez == 1 && <div className="badge2"></div>
                                    } */}

                                  </div>


                                </div>
                              </div>
                            </div>
                          );
                        })
                      ) : <button onClick={() => { history.push('add-auction-player') }} className="customaddbtn">Add Player</button>}
                    </div>
                  </div>
                </div>
              </section>
            </div>
          </div>
        </div>
      </LoadingOverlay>
    </>
  );
}

export default Players;
